import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Link } from '@mui/material'

const Logo = ({ disabledLink = false, sx, src, ...other}) => {

    const logo = (
        <Box
            id="app-logo"
            {...other}
            component="img"
            src={src || '/logo/logo_xs.png'}
            sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
        />
    )

    if (disabledLink) {
        return logo
    }

    return (
        <Link id="app-logo" component={RouterLink} to="/" sx={{ display: 'contents' }}>
            {logo}
        </Link>
    )
}

Logo.propTypes = {
    sx: PropTypes.object,
    disabledLink: PropTypes.bool,
    src : PropTypes.string
}

export default Logo
